<template>
    <div v-if="labels">
        <div class="grid-container">
            <div class="grid-x">

                <div class="head head--blue cell">
                    <div class="head__content">
                        <h1 class="head__title">{{labels.jobEffects}}</h1>
                    </div>

                    <!-- Filter -->
                    <searchFilter v-if="searchFilter && labels" @searchEvent="search"></searchFilter>

                    <div class="loader__wrapper loader__wrapper--loading loader__wrapper--md" v-else>
                        <div class="loader">
                            <div class="loader__circle loader__circle--in-head"></div>
                            <div class="loader__text">{{labels.loadingSearchCriteria}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-container" :class="{'loader__wrapper--loading': showUpdateBtn}">
            <div class="loader loader--no-animation">
                <div class="loader__text">
                    <p class="lead lead--pull-down">
                        <b v-if="!searching">{{labels.theSearchCriteriaHaveBeenChanged}}</b>
                        <b v-if="searching">{{labels.updating}}</b>
                    </p>
                </div>
            </div>
            <div class="grid-x">
                <div v-if="searchResult && searchResult.jobeffectViewModels.length > 0" class="cell">

                    <!-- Jobeffect table -->
                    <effects 
                        :result="searchResult.jobeffectViewModels" 
                        :showEffectColumn="showEffectColumn" 
                        :showSortOptions="true"
                        :type="'effect'" 
                        :labels="labels"></effects>

                    <!-- We only render combination box if there are any normal results if positive only has been chosen -->
                    <template v-if="anyPositiveResultsIfPositiveOnly(searchResult.jobeffectViewModels)">
                        <!-- Jobeffect combination table toggle -->
                        <div class="combi text-center" v-if="!showCombi">
                            <button class="button combi__button" :disabled="searchComboLoading"  @click="searchCombi" @keyup.enter="searchCombi">{{labels.show}} {{ labels.combinationInterventions }}</button>
                        </div>
                        <div class="combi combi--active" v-else>
                            <h2 class="combi__title">{{ labels.combinationInterventions }}<button @click="showCombi = false" @keyup.enter="showCombi = false" class="button small outline">{{labels.hide}}</button></h2>
                        </div>

                        <!-- Jobeffect combination table -->
                        <effects 
                            v-if="showCombi"
                            :result="searchResultCombi" 
                            :showEffectColumn="showEffectColumn" 
                            :showSortOptions="false"
                            :type="'combi'"
                            :labels="labels"
                            @searchCombi="searchCombi"
                            :searchComboLoading="searchComboLoading"></effects>

                        <div class="content__no-results" v-if="showCombi && searchResultCombi.length === 0">
                            <p class="lead">{{labels.noCombiJobEffectsWereFound}}</p>
                        </div>
                    </template>

                   

                    <buttons :hideExport="true" :texts="modalLabels()" :saveStatus="saveStatus" @save="save($event)"></buttons>
                </div>
                <div class="content__no-results" v-else-if="searchResult === null">
                    <p class="lead">{{labels.selectAtLeastOne}}</p>
                </div>
                <div class="content__no-results" v-else>
                    <p class="lead">{{labels.noJobEffectsWereFound}}</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { each, some, union } from "lodash";
import { getSelectedIds } from "@/tools/tools.js";
export default {
    name: "Search",
    data() {
        return {
            loaded: false,
            resultLoaded: false,
            showEffectColumn: false,
            saveStatus: null,
            searchComboLoading: false,
            showCombi: false
        };
    },
    computed: {
        searchFilter() {
            return this.$store.state.searchFilter;
        },
        searchResultCombi() {
            return this.$store.state.searchCombi !== null ? this.$store.state.searchCombi.jobeffectViewModels : [];
        },
        searchResult() {
            return this.$store.state.search;
        },
        showUpdateBtn() {
            return (
                this.$store.state.searchFilterDirty &&
                this.searchResult !== null && this.searchResult.jobeffectViewModels.length > 0
            );
        },
        searching() {
            return this.$store.state.searching;
        },
        labels() {
            return this.$store.state.labels["pages.jobeffects"];
        }
    },
    mounted() {
        // IMPORTANT - this component is kept alive and mounted lifecycle hook is not fired when 
        // navigating back to search page from details or study page 
        // A. Use searchfilter from store and search
        // B. Grab url params -> use when getting searchFilter, then search
        // C. Just get a fresh searchfilter + defaults
        if (this.searchFilter !== null) {
            this.search(this.searchFilter);
        } else if (typeof this.$route.query["id"] !== "undefined") {
            this.$store
                .dispatch("getSearchFilterWithParams", this.$route.query.id)
                .then(() => {
                    this.search();
                });
        } else {
            this.$store.dispatch("getSearchFilter");
        }
        
        this.$store.dispatch("getLabels", { label: "pages.jobeffects" });
    },
    activated(){
        // Fires when navigated back from details / study page 
        // and after mounted (after mounted searfilterdirty is false)
        if(this.$store.state.searchFilterDirty) {
           if(this.searchFilter !== null){
                this.search(this.searchFilter);
           } else {
                this.$store.dispatch("getSearchFilter");
           }
        }
    },
    methods: {
        search() {
            this.showEffectColumn = this.anySelected(this.searchFilter.effects);
            this.$store.dispatch("search", this.searchFilter);
            this.saveStatus = null;
            this.showCombi = false;
            this.$store.commit('EXPANDCOMBITABLE', false);
        },
        searchCombi(){
            this.searchComboLoading = true;
            this.$store.dispatch('searchCombi', this.searchFilter).then(() => {
                this.searchComboLoading = false;
                this.showCombi = true;
            });
        },
        anySelected(section) {
            var any = false;
            each(section, tab => {
                each(tab.optionGroups, group => {
                    if (
                        some(group.options, option => {
                            return option.isSelected === true;
                        })
                    ) {
                        any = true;
                    }
                });
            });
            return any;
        },
        save(data) {
            var ids = [];
            each(this.searchFilter, item => {
                ids = union(getSelectedIds(item), ids);
            });

            this.$store
                .dispatch("save", {
                    type: "search-criterias",
                    name: data.name,
                    description: data.msg,
                    jobeffectsSearchCriteria: {
                        selectedIds: ids,
                        positiveOnly: this.$store.state.positiveOnly
                    }
                })
                .then(() => {
                    this.saveStatus = "succes";
                })
                .catch(error => {
                    this.saveStatus = "error";
                    console.warn(error);
                });
        },
        modalLabels() {
            return {
                saveDialog: {
                    name: this.labels.saveInMyLibraryName,
                    title: this.labels.saveInMyLibraryTitle,
                    text: this.labels.saveInMyLibraryText,
                    succes: this.labels.saveInMyLibrarySucces,
                    error: this.labels.saveInMyLibraryError,
                    button: this.labels.saveInMyLibraryButton,
                    note: this.labels.saveInMyLibraryNote
                },
                emailDialog: {
                    button: this.labels.tipEmailButton,
                    message: this.labels.tipEmailMessage,
                    receiverEmail: this.labels.tipEmailRecieverEmail,
                    receiverName: this.labels.tipEmailRecieverName,
                    senderEmail: this.labels.tipEmailSenderEmail,
                    senderName: this.labels.tipEmailSenderName,
                    success: this.labels.tipEmailSuccess,
                    text: this.labels.tipEmailText,
                    title: this.labels.tipEmailTitle
                }
            };
        },
        anyPositiveResultsIfPositiveOnly(table) {
            let positiveResults = some(table, (item) => {
                return item.algorithmResult.jobeffekt === 0 
            })
            return !this.$store.state.positiveOnly || positiveResults;
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/jobeffects-search/Search.vue